module.exports = __webpack_public_path__ + "static/media/Competency_Management.14908cbd.png";